import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import api from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { useSeo } from "@/lib/seo";
import { ProfileSettings } from "@/components/profile/ProfileSettings";

export default function Profile() {
    useSeo({ title: "Il mio profilo | VendiDirect", description: "Gestisci accesso, privacy e configurazione email.", noindex: true });
    const { user, refresh } = useAuth();

    const setContactsPublic = async (nextValue) => {
        await api.put("/auth/profile", { contacts_public: !!nextValue });
        await refresh();
    };

    if (!user) {
        return <div data-testid="profile-auth-required" className="pt-32 text-center text-ink-400">Effettua l'accesso per gestire il profilo.</div>;
    }

    return (
        <main data-testid="profile-page" className="pt-32 pb-24 w-full px-4 sm:px-6 md:px-12 lg:px-20 2xl:px-28">
            <div className="max-w-7xl mx-auto">
                <Link to={user?.plan_id === "agenzia" ? "/analytics-pro" : "/dashboard"} data-testid="profile-back-link" className="profile-back-link mb-6">
                    <ArrowLeft size={15} /> {user?.plan_id === "agenzia" ? "Torna al VD Manager" : "Torna alla Dashboard"}
                </Link>
                <ProfileSettings user={user} onContactsPublic={setContactsPublic} onRefresh={refresh} />
            </div>
        </main>
    );
}